<template src="./index.tpl.html"></template>

<script>
import dataStore from "@/services/api/store";
import survey from "./survey";
import moment from "moment";
import raffleHub from "@/services/hubs/raffle";

const QUESTIONS_STORE = "ClientSurveyQuestionAnswer";
const SURVEY_STORE = "ClientSurveys";
const KPI_STORE = "ClientKPI";

export default {
  components: {
    survey
  },
  data() {
    return {
      goalAnswer: undefined,
      reflection: "",
      userAnswer: {},
      saving: false,
      surveyQuestions: [],
      loading: true,
      preview: false,
      btnValue: "Save",
      kpis: []
    };
  },
  created() {
    dataStore
      .create("ClientSurveys", { daily_survey: true }, { force: true })
      .then(survey => {
        this.userAnswer = survey;
        this.surveyQuestions = survey.answers;
        this.$eventHub.$emit("tutorial", "dailyReflection");
      })
      .finally(() => (this.loading = false));

      dataStore.findAll(KPI_STORE, { limit: 500, survey: true }, {force: true}).then(kpis => {
        this.kpis = kpis.map(k => ({...k, result: undefined}));
      });

  },

  methods: {
    updateAnswer() {},
    updateGoal(n) {
      this.goalAnswer = n;
    },
    save() {
      if (this.surveyQuestions.some(q => !q.answer)) {
        this.$emit("displaySnackbar", "Make sure everything is filled out");
        return;
      }

      this.kpis
        .filter(kpi => kpi.result !== undefined)
        .map(kpi => {
          return {
            kpi: kpi.id,
            reflection: this.userAnswer.token,
            result: kpi.result
          };
        })
        .map(kpiResult => dataStore.create("ClientKPIResult", kpiResult));

      this.userAnswer.reflection = this.reflection;
      this.userAnswer.completed_at = moment().format();
      this.saving = true;
      let a = dataStore.update(
        SURVEY_STORE,
        this.userAnswer.token,
        this.userAnswer
      );


      Promise.all([
        a,
        ...this.surveyQuestions.map(q =>
          dataStore.update(QUESTIONS_STORE, q.id, q)
        ),
      ]).then(() => {
        this.kpis = [];
        this.$emit("displaySnackbar", "Saved");
        this.saving = false;
        raffleHub.update("pulse_survey");
        this.$router.push("/progress");
      });
    }
  }
};
</script>

<style>
.active {
  color: blue;
}

.big-label {
  font-size: 14px;
  opacity: 0.8;
  padding-bottom: 10px;
}

.rating {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  text-transform: uppercase;
  font-size: 10px;
  letter-spacing: 1px;
  padding-bottom: 15px;
}

.radio {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.group {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}

.question {
  padding-top: 25px;
  font-size: 15px;
  letter-spacing: 1px;
  padding-bottom: 8px;
  font-weight: 400;
  opacity: 0.9;
}
</style>
